import '~/core/shared/styles/react-day-picker.css';
import { SystemConfig } from '@chakra-ui/react';

const dayPickerStyles: SystemConfig['globalCss'] = {
  '.rdp-month_caption': {
    pl: 2,
  },
  '.rdp-caption_label': {
    fontSize: 'md',
    fontWeight: 'normal',
    gap: 3,
  },
  '.rdp-dropdowns': {
    gap: 6,
  },
  '.rdp-day': {
    '&[aria-disabled="false"]': {
      _hover: {
        bg: `{colors.secondary.750} !important`,
      },
    },
    borderRadius: '50%',
    fontSize: 'sm',
  },
  '.rdp-day, .rdp-weekday': {
    boxSize: '2.5rem',
    p: 0,
    verticalAlign: 'middle',
  },
  '.rdp-today': {
    color: `{colors.white} !important`,
  },
  '.rdp-chevron': {
    fill: 'black',
  },

  '.rdp-selected': {
    bg: `{colors.secondary.800} !important`,
    color: `{colors.primary.500} !important`,
  },
  '.rdp-selected .rdp-day_button': {
    border: 'none',
  },
  '.rdp-selected, .rdp-today, .rdp-weekday': {
    fontWeight: 'bold',
  },
  '.rdp-weekday': {
    color: 'whiteAlpha.700',
    fontSize: 'xs',
  },
  '.rdp-root': {
    bg: 'secondary.700',
    borderColor: 'secondary.750',
    borderRadius: 'sm',
    minWidth: '300px',
    borderWidth: '1px',
    shadow: 'lg',
  },
};

export default dayPickerStyles;
